import React, { useEffect, useState } from "react";
import { getPowertoolsList } from "../../../services/apiService";

const ToolsStockManagement = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    loadStock();
  }, []);

  const loadStock = async () => {
    try {
      const data = await getPowertoolsList();

      const formatted = data.map((item) => ({
        productId: item.productid,
        name: item.modelno,
        stock: item.stock ?? 0,
        stockminqty: item.stockminqty ?? 0,   
        subcategory: item.subcategory,
      }));

      setProducts(formatted);
    } catch (e) {
      console.log("Error loading stock", e);
    }
  };

  // ✅ Stock Status Logic
  const getStockStatus = (stock, stockminqty) => {
    const stk = Number(stock);
    const min = Number(stockminqty);

    if (stk === 0) return "Out of Stock";
    if (stk <= min) return "Low Stock";
    return "In Stock";
  };

 const getStockColor = (stock, minQty) => {
  if (stock === 0) return "low-stock";
  if (stock <= minQty) return "low-stock";
  return "good-stock";
};

  // ✅ Filtering
  const filteredProducts = products.filter((item) => {
    const searchText = search.toLowerCase();

    if (searchText === "low stock" || searchText === "red") {
      return Number(item.stock) <= Number(item.stockminqty);
    }

    if (searchText === "green" || searchText === "in stock") {
      return Number(item.stock) > Number(item.stockminqty);
    }

    if (searchText === "out of stock") {
      return Number(item.stock) === 0;
    }

    return (
      item.name.toLowerCase().includes(searchText) ||
      item.productId.toString().includes(searchText)
    );
  });

  // ✅ Pagination
  const totalPages = Math.ceil(filteredProducts.length / pageSize);
  const startIndex = (page - 1) * pageSize;
  const paginatedProducts = filteredProducts.slice(
    startIndex,
    startIndex + pageSize
  );

  return (
    <div className="stock-container">
      <h2>Tools Stock Management</h2>

      <input
        type="text"
        placeholder="Search Product / low stock / green / out of stock"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
        className="search-box"
      />

      <table className="stock-table">
        <thead>
          <tr>
            <th>ProductId</th>
            <th>Modelno</th>
            <th>Category</th>
            <th>StockMinQty</th>
            <th>Stock</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {paginatedProducts.map((item, index) => (
            <tr key={index}>
              <td>{item.productId}</td>
              <td>{item.name}</td>
              <td>{item.subcategory}</td>
              <td>{item.stockminqty}</td>
              <td>{item.stock}</td>

              <td>
              <button
  className={`status ${getStockColor(item.stock, item.stockminqty)}`}
>
  {item.stock === 0
    ? "Out of Stock"
    : item.stock <= item.stockminqty
      ? "Low Stock"
      : "In Stock"}
</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination-container">
        <div>
          Items per page:
          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="page-buttons">
          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>

          <span className="page-count">
            {page} / {totalPages || 1}
          </span>

          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <style>{`
        .stock-container{
          padding:20px;
          background:white;
          font-family:Arial;
        }

        .search-box{
          padding:8px;
          width:300px;
          margin-bottom:15px;
          border:1px solid #ccc;
          border-radius:4px;
        }

        .stock-table{
          width:100%;
          border-collapse:collapse;
        }

        .stock-table th{
          background:#f5f5f5;
          padding:10px;
          border:1px solid #ddd;
          text-align:left;
        }

        .stock-table td{
          padding:10px;
          border:1px solid #ddd;
        }

        .stock-table tr:hover{
          background:#fafafa;
        }

        .status {
          width:120px;
          height:28px;
          border:none;
          border-radius:5px;
          color:white;
          font-size:12px;
          cursor:default;
        }

        .low-stock{
          background:#e74c3c;
        }

        .good-stock{
          background:#2ecc71;
        }

        .out-of-stock{
          background:#7f8c8d;
        }

        .pagination-container{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-top:20px;
          padding:10px;
          border-top:1px solid #eee;
        }

        .page-select{
          padding:6px 10px;
          border:1px solid #ccc;
          border-radius:5px;
          margin-left:5px;
          cursor:pointer;
        }

        .page-buttons{
          display:flex;
          align-items:center;
          gap:10px;
        }

        .page-btn{
          padding:6px 14px;
          border:none;
          border-radius:5px;
          background:#3498db;
          color:white;
          cursor:pointer;
        }

        .page-btn:hover{
          background:#2980b9;
        }

        .page-btn:disabled{
          background:#ccc;
          cursor:not-allowed;
        }

        .page-count{
          font-weight:bold;
          color:black;
        }
      `}</style>
    </div>
  );
};

export default ToolsStockManagement;